import { cn } from '@/utils/cn';

/**
 * The Wonder mark.
 *
 * The paths are the real export from `src/assets/images/join_wonder_logo.svg`,
 * inlined rather than loaded through an `<img>` so the mark can inherit the
 * colour of the text beside it: the export ships two `fill="white"` paths,
 * which would be invisible the moment the mark appeared on a light surface.
 * `currentColor` makes it work on both without a second asset.
 *
 * Sized off `size` as the width, with the height derived from the artwork's
 * own 53x50 ratio, so a caller never has to keep two numbers in step.
 */
const RATIO = 50 / 53;

export function Logo({ className, size = 53, title = 'Wonder', ...rest }) {
  return (
    <svg
      viewBox="0 0 53 50"
      width={size}
      height={size * RATIO}
      role="img"
      aria-label={title}
      className={cn('shrink-0', className)}
      fill="currentColor"
      // e.g. `aria-hidden` where the name is written beside the mark.
      {...rest}
    >
      <path d="M11.7677 48.4419C10.7934 48.063 10.05 47.4062 9.51953 46.6989L31.1747 25.17L49.3116 42.9748L49.2935 0.335599C50.0766 -0.00721784 51.2025 0.137126 51.9711 0.765023L52.0216 49.4739L31.182 29.0456L11.7605 48.4455L11.7677 48.4419Z" />
      <path d="M6.08771 39.3085L25.1736 20.1937C25.9567 20.6412 26.6495 21.2511 27.2738 22.0377L0.0505204 49.1852L0 0L2.91936 0.653157V42.7078L6.08771 39.3049V39.3085Z" />
    </svg>
  );
}
